import styled from 'styled-components';

/**
 * This wrapper should not be used with customer-supplied SVG assets.
 *
 * Not all SVGs work with non-scaling-stroke, and are likely already properly colored.
 * Pass the `vectorEffect` prop to override.
 *
 * Some SVGs have fills or strokes that shouldn't change with theme. These
 * should be given the class .no-theme.
 *
 * Don't use with CustomizablePictograph; that has theming built in.
 */
export default styled('div')<{
  $primaryColor?: string | null;
  $highlightColor?: string | null;
  $backgroundColor?: string | null;
  $strokeColor?: string | null;

  vectorEffect?: 'initial' | 'non-scaling-stroke';
}>`
  circle[stroke]:not(.no-theme),
  rect[stroke]:not(.no-theme),
  path[stroke]:not(.no-theme),
  g[stroke]:not(.no-theme) {
    stroke: ${({ $strokeColor, theme }) => $strokeColor ?? theme.iconColorStroke};
    vector-effect: ${({ vectorEffect }) => vectorEffect ?? 'non-scaling-stroke'};
  }

  circle[fill]:not([fill='none']):not(.no-theme),
  rect[fill]:not([fill='none']):not(.no-theme),
  path[fill]:not([fill='none']):not(.no-theme),
  g[fill]:not([fill='none']):not(.no-theme) {
    fill: ${({ $primaryColor, theme }) => $primaryColor ?? theme.iconColorPrimary};
  }

  circle[fill].icon-color-highlight,
  rect[fill].icon-color-highlight,
  path[fill].icon-color-highlight,
  g[fill].icon-color-highlight {
    fill: ${({ $highlightColor, theme }) => $highlightColor ?? theme.iconColorHighlight} !important;
  }

  circle[fill].icon-color-background,
  rect[fill].icon-color-background,
  path[fill].icon-color-background,
  g[fill].icon-color-background {
    fill: ${({ $backgroundColor, theme }) =>
      $backgroundColor ?? theme.iconColorBackground} !important;
  }

  circle[fill].icon-color-stroke,
  rect[fill].icon-color-stroke,
  path[fill].icon-color-stroke,
  g[fill].icon-color-stroke {
    fill: ${({ $strokeColor, theme }) => $strokeColor ?? theme.iconColorStroke} !important;
  }

  /* Stop SVGs from taking up more vertical space than they should in flex layouts */
  line-height: 0;
`;
